import { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { ReactCompareSlider, ReactCompareSliderImage } from "react-compare-slider";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function RealisationsPage() {
    const [projects, setProjects] = useState([]);

    useEffect(() => {
        window.scrollTo(0, 0);
        axios.get(`${API}/projects`).then((r) => setProjects(r.data.projects || [])).catch(() => {});
    }, []);

    return (
        <div data-testid="realisations-page" className="min-h-screen bg-[#FAF9F6]">
            <Navbar />
            <main className="pt-32 pb-24">
                <div className="max-w-[1500px] mx-auto px-6 md:px-12">
                    <div className="mb-16">
                        <div className="flex items-center gap-3 mb-6">
                            <span className="h-px w-10 bg-[#B89C6A]" />
                            <span className="tracking-luxe text-[#B89C6A]">Portfolio · Avant / Après</span>
                        </div>
                        <h1 className="font-serif-lux text-4xl md:text-5xl lg:text-6xl leading-[1.02] max-w-4xl">
                            Nos <em className="italic text-[#B89C6A]">réalisations</em>, la preuve par l'image.
                        </h1>
                        <p className="mt-6 max-w-2xl text-[15px] text-[#1C1E1D]/70 leading-relaxed">
                            Rénovations complètes, constructions sur mesure — faites glisser le curseur sur chaque projet pour révéler la transformation signée CM RENOV à Paris et en Île-de-France.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                        {projects.map((p, i) => (
                            <figure key={p.id} data-testid={`realisation-${p.id}`}>
                                <div className="aspect-[16/11] overflow-hidden border hairline">
                                    <ReactCompareSlider
                                        itemOne={<ReactCompareSliderImage src={p.before} alt={`Avant — ${p.title}`} />}
                                        itemTwo={<ReactCompareSliderImage src={p.after} alt={`Après — ${p.title}`} />}
                                        position={50}
                                        style={{ height: "100%" }}
                                    />
                                </div>
                                <figcaption className="mt-5">
                                    <div className="tracking-luxe text-[#B89C6A] text-[10px]">
                                        {String(i + 1).padStart(2, "0")} · {[p.category, p.location].filter(Boolean).join(" · ")}
                                    </div>
                                    <h2 className="font-serif-lux text-2xl mt-2">{p.title}</h2>
                                    {p.description && (
                                        <p className="text-[13px] text-[#1C1E1D]/70 mt-2 leading-relaxed max-w-lg">{p.description}</p>
                                    )}
                                </figcaption>
                            </figure>
                        ))}
                    </div>

                    {projects.length === 0 && (
                        <p className="text-[14px] text-[#1C1E1D]/50 italic">Nos réalisations arrivent bientôt.</p>
                    )}

                    <div className="mt-20 bg-[#1C1E1D] text-[#FAF9F6] p-10 md:p-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
                        <div>
                            <div className="tracking-luxe text-[#B89C6A] mb-3">Votre projet mérite le même soin</div>
                            <h2 className="font-serif-lux text-3xl md:text-4xl">Parlons de votre <em className="italic text-[#B89C6A]">transformation</em>.</h2>
                        </div>
                        <a href="/#devis" data-testid="realisations-cta"
                            className="inline-flex items-center px-7 py-3.5 bg-[#B89C6A] text-[#1C1E1D] text-[11px] font-medium tracking-[0.18em] uppercase hover:bg-[#FAF9F6] transition-colors shrink-0">
                            Estimer mon projet →
                        </a>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
}
